// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1RCly","buttons":"RemoveExpirationActionButtons_buttons__23rIz"};